import Rete from 'rete'
import { nanoid } from 'nanoid/async'

import { App } from '../../App'
import CONST_SOCKET from '../../const/socket'
import { referenceModal } from './referenceModal'
import { 
  removeNodes,
  addNewSequenceToEditor,
  addNewSequenceSingleToEditor, 
  updateNodeConnections,
  fixYPositionOfChildComponents, 
  getNodeInputConnectionsBySocketName,
} from '../../utils/functions'

const isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { 
    value: referenceData, 
    isConfirmed: isClickedOkButton, 
  } = await referenceModal(oldData, node)

  if (referenceData && Object.values(referenceData).length > 0) {
    // Create post-back ID if there is not any
    if (! ('postbackId' in node.data)) {
      const data = {
        title: referenceData.title,
        postbackId: await nanoid(15),
        xitFbpostbackId: await nanoid(36),
      }

      Object.assign(node.data, data)
    }
    
    Object.assign(node.data, referenceData)

    if ('newSequence' === referenceData.sequenceIdValue) {
      node.referenceNodeSequenceSocketStatus = false
      if (node.outputs instanceof Map) {
        const referenceOutputSequence = node.outputs.get(CONST_SOCKET.REFERENCE_OUTPUT_SEQUENCE)
        if (referenceOutputSequence instanceof Rete.Output) {
          if (0 === referenceOutputSequence.connections.length) {
            attachNewSequenceAndChildrenToReferenceNode(node)
          }
        }
      }
    }

    if ('newSequence' !== referenceData.sequenceIdValue) {
      node.referenceNodeSequenceSocketStatus = true
      if (isClickedOkButton && node.referenceNodeNewSequenceValueChangeStatus) {
        if (node.referenceNodeChildrenComponents 
          && node.referenceNodeChildrenComponents instanceof Map
        ) {
          const nodesList = node.referenceNodeChildrenComponents.get('node-id-' + node.id)
          
          if (nodesList) {
            removeNodes(nodesList)
            node.referenceNodeChildrenComponents.delete('node-id-' + node.id)
          }
        }
      }
    }

    node.update()

    if (isSequenceAddonAvailable) {
      toggleSequenceSocketIfNewSequenceIsSelected(node)
    }
    
    updateNodeConnections(node)
  }

  return false
}

const attachNewSequenceAndChildrenToReferenceNode = async (node) => {
  const newSequenceNodePosition = [node.position[0] + 320, node.position[1] + 40]
  const newSequenceNode = await addNewSequenceToEditor(newSequenceNodePosition)

  const nodeList = [newSequenceNode]

  App.editor.connect(
    node.outputs.get(CONST_SOCKET.REFERENCE_OUTPUT_SEQUENCE),
    newSequenceNode.inputs.get(CONST_SOCKET.SEQUENCE_INPUT)
  )

  const items = [1, 2, 3]
  
  // eslint-disable-next-line
  items.map(async (item, index) => { 
    const sequenceSingleNodePositionY = fixYPositionOfChildComponents(index, 120, items.length)
    const squenceSingleNodePosition = [node.position[0] + 650, sequenceSingleNodePositionY]
    const sequenceSingleNode = await addNewSequenceSingleToEditor(squenceSingleNodePosition)

    nodeList.push(sequenceSingleNode)

    App.editor.connect(
      newSequenceNode.outputs.get(CONST_SOCKET.SEQUENCE_OUTPUT),
      sequenceSingleNode.inputs.get(CONST_SOCKET.SEQUENCE_SINGLE_INPUT)
    )

  })

  const componentsMap = new Map()
  componentsMap.set('node-id-' + node.id, nodeList)
  node.referenceNodeChildrenComponents = componentsMap
}

const toggleSequenceSocketIfNewSequenceIsSelected = (node) => {
  const componentElement = $(node.vueContext.$el)

  const referenceOutputSequenceClass = CONST_SOCKET.REFERENCE_OUTPUT_SEQUENCE.toLowerCase()
  const targetElementNode = componentElement.find('.' + referenceOutputSequenceClass).parent()

  if (('sequenceIdValue' in node.data) && ('newSequence' === node.data.sequenceIdValue)) {
    targetElementNode.removeClass('d-none').addClass('d-block')
  } else {
    targetElementNode.removeClass('d-block').addClass('d-none')
  }
}